import styled from "styled-components";

export const LeftIcon = styled.div`
    order: 0;
    flex: 0 1 auto;
    align-self: auto;
    padding-right: 12px;
`;
